export enum InGameAccountModalStatusEnum {
  NO_ACCOUNT = 'NO_ACCOUNT',
  GUEST = 'GUEST',
  ACCOUNTS = 'ACCOUNTS',
  EDIT = 'EDIT',
  ADD = 'ADD',
}
